import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import * as LayoutActions from '@layout/store/layout.actions';
import * as CompaniesPageActions from '@modules/companies/store/companies-page.actions';
import { Company } from '@shared/models';

import * as CompaniesActions from './companies.actions';

export interface CompaniesState extends EntityState<Company> {
  selectedId?: number;
}

export const companiesAdapter: EntityAdapter<Company> = createEntityAdapter<Company>({
  selectId: (company: Company) => company.id,
  sortComparer: false,
});

export const initialState: CompaniesState = companiesAdapter.getInitialState({
  selectedId: null,
});

const reducer = createReducer(
  initialState,
  on(CompaniesActions.companiesLoadSuccess, (state, { companies }) => companiesAdapter.upsertMany(companies, state)),
  on(CompaniesPageActions.companiesLoadPageSuccess, LayoutActions.layoutHeaderLoadCompaniesSuccess, (state, { payload }) =>
    companiesAdapter.upsertMany(payload.content, state),
  ),
  on(CompaniesActions.companiesGetSuccess, (state, { company }) => companiesAdapter.upsertOne(company, state)),
  on(CompaniesActions.companiesSelect, (state, { id }) => ({ ...state, selectedId: id })),
  on(CompaniesActions.companiesUpdateSuccess, CompaniesActions.companiesCreateSuccess, (state, { company }) =>
    companiesAdapter.upsertOne(company, state),
  ),
);

export function companiesReducer(state: CompaniesState | undefined, action: Action) {
  return reducer(state, action);
}
